/**
 * Een schakelaarregel omzetten: alles aan of alles uit. R47 stap 2.
 *
 * WAAROM DIT EEN EIGEN BESTAND IS. Sinds er per PROJECT wordt geschakeld draagt
 * een regel MEER dan een bank, en "omzetten" is dus niet langer een id in een
 * lijst gooien. Er zit een beslissing in: staat de regel aan (alle banken erin)
 * of niet, en wat gebeurt er met een HALVE stand. Die beslissing zat in een
 * `useCallback` binnen `ChatPage`, waar zij alleen via een heel scherm te
 * toetsen was.
 *
 * Dat is de situatie uit CLAUDE.md 4.8c: kan iets alleen via de omweg getoetst
 * worden, dan staat de beslissing op de verkeerde plek. Hier staat zij als pure
 * functie en wordt zij op UITKOMST getoetst.
 */

/**
 * De nieuwe lijst aangezette BANKEN na een klik op een regel.
 *
 * `huidig` is de lijst bank-ids die nu aan staat, `ids` zijn de banken van de
 * aangeklikte regel.
 *
 * EEN HALVE STAND GAAT HELEMAAL AAN EN NIET HELEMAAL UIT, en dat is de keuze
 * die hier vastligt. Half aan ontstaat wanneer er een bank bij een project komt
 * nadat het is aangezet. Klikt iemand dan, dan is de bedoeling vrijwel zeker
 * "dit project erbij" en niet "gooi ook weg wat er al aan stond". Uitzetten
 * vergt dus een tweede klik, en dat is de goedkope kant van de vergissing.
 */
export function zetOm(huidig, ids) {
  const regel = Array.isArray(ids) ? ids : [ids];
  const overig = (huidig || []).filter((id) => !regel.includes(id));
  // EEN LEGE REGEL HEEFT HIER GEEN EIGEN GORDEL NODIG, en dat is gemeten en
  // niet aangenomen. Hier stond `regel.length > 0 &&`, met als toelichting dat
  // `every` op een lege lijst WAAR is en dat dit anders alles zou uitzetten.
  // Een mutatie die die voorwaarde weghaalde liet alle 887 toetsen groen, en
  // het nameten wijst uit waarom: bij een lege regel filtert `overig` niets weg
  // en zijn `overig` en `[...overig, ...regel]` allebei gelijk aan `huidig`.
  // Beide takken geven dus hetzelfde terug en de gordel bewaakte niets.
  //
  // Weggehaald in plaats van laten staan, om dezelfde reden als bij de lege
  // `in_()` in `reindex_estimated.py` diezelfde dag: een wacht die niets
  // bewaakt suggereert dekking die er niet is. De toets eromheen blijft staan
  // en meet nu wat de bescherming werkelijk is, namelijk het filteren zelf.
  const staatHelemaalAan = regel.every((id) => (huidig || []).includes(id));
  return staatHelemaalAan ? overig : [...overig, ...regel];
}

/**
 * ZOEK OVERAL (R47 stap 3, punt i van de planning, Frank 21 oktober 2026): alle
 * banken van alle regels in het menu, ieder een keer. Een regel zonder
 * `base_ids` is zelf een bank, zoals in `SwitchMenu`.
 */
export function alleBanken(regels) {
  const ids = (regels || []).flatMap((r) => (r.base_ids && r.base_ids.length ? r.base_ids : [r.id]));
  return [...new Set(ids)];
}

/** Of alle banken van het menu al aan staan; dan heeft Zoek overal niets te doen. */
export function alAllesAan(regels, huidig) {
  const aan = new Set(huidig || []);
  const alle = alleBanken(regels);
  return alle.length > 0 && alle.every((id) => aan.has(id));
}

/**
 * GL211-2 (glasronde 0.9.211, Frank 28 oktober 2026): kennisbank en project met dezelfde naam zijn
 * een ding. Het project waar een gesprek ZONDER project heen gaat na deze klik, of null.
 *
 * Alleen als er nog niets aan stond, zodat "DOQENT en QIS erbij" een los gesprek blijft, en alleen
 * voor een project waarvan een bank standaard meeweegt (`standaard_aan`). In een project met
 * alleen `default_off`-banken, zoals Archief, vielen die banken na het verplaatsen juist uit.
 */
export function koppelProject(huidig, regel, gesprekProject) {
  if (gesprekProject || !regel || !regel.standaard_aan) return null;
  return (huidig || []).length === 0 ? regel.id : null;
}
